import { Button, LoadingButton } from '@one-thd/sui-atomic-components';
import React from 'react';
export var AddReceiptDrawerFooter = function (_a) {
    var closeDrawer = _a.closeDrawer, handleButtonClick = _a.handleButtonClick, isLoading = _a.isLoading, primaryButtonText = _a.primaryButtonText, reset = _a.reset, secondaryButtonText = _a.secondaryButtonText;
    return (React.createElement("div", { className: "ButtonGroup sui-min-w-full sui-flex sui-gap-4 sui-flex-col sui-p-4" },
        React.createElement(LoadingButton, { loading: isLoading, onClick: handleButtonClick, variant: "primary" }, primaryButtonText),
        React.createElement(Button, { disabled: isLoading, onClick: function () {
                closeDrawer();
                reset();
            }, variant: "secondary" }, secondaryButtonText)));
};
